import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Navbar.css'; // Or use Tailwind CSS

const languages = [
  { code: 'en', label: 'English', flag: 'https://flagcdn.com/gb.svg' },
  { code: 'fr', label: 'Français', flag: 'https://flagcdn.com/fr.svg' },
  { code: 'es', label: 'Español', flag: 'https://flagcdn.com/es.svg' },
  { code: 'ar', label: 'العربية', flag: 'https://flagcdn.com/sa.svg' },
];

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang =
    languages.find((lang) => lang.code === i18n.language.toLowerCase()) || languages[0];

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr';
    setOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="language-dropdown relative inline-block text-left" ref={dropdownRef}>
      <button
        className="dropdown-toggle flex items-center gap-2 px-3 py-2 border rounded hover:bg-gray-100"
        onClick={() => setOpen(!open)}
      >
        <img src={currentLang.flag} alt={currentLang.label} className="w-5 h-4" />
        <span>{currentLang.label}</span>
        <span className="text-sm">▼</span>
      </button>

      {open && (
        <ul className="dropdown-menu absolute mt-2 w-40 bg-white border rounded shadow-md z-50">
          {languages.map((lang) => (
            <li
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <img src={lang.flag} alt={lang.label} className="w-5 h-4" />
              <span>{lang.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
